import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SearchFilterWrapperComponent } from './search-filter-wrapper.component';
import { SearchFilterModule } from '../search-filter/search-filter.module';


@NgModule({
    imports: [
        CommonModule,
        NgZorroAntdModule,
        SearchFilterModule
    ],
    declarations: [ SearchFilterWrapperComponent ],
    exports: [ SearchFilterWrapperComponent ]
})
export class SearchFilterWrapperModule { }
